import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e7140d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "category-menu"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "col-12 bg-white" }
const _hoisted_4 = {
  key: 0,
  class: "row"
}
const _hoisted_5 = { class: "col col-4 border-right" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col px-0" }
const _hoisted_8 = { class: "py-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-2 font-weight-bold mb-1 d-block" }, "Productos", -1))
const _hoisted_10 = { class: "list-unstyled m-0" }
const _hoisted_11 = ["onClick", "onMouseenter"]
const _hoisted_12 = {
  key: 0,
  class: "list-unstyled m-0"
}
const _hoisted_13 = ["onMouseenter"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-3 px-2 font-weight-bold mb-1 d-block" }, "Servicios", -1))
const _hoisted_16 = { class: "list-unstyled m-0" }
const _hoisted_17 = ["onMouseenter"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "col px-0 border-left"
}
const _hoisted_20 = {
  key: 0,
  class: "py-3"
}
const _hoisted_21 = { class: "px-2 font-weight-bold mb-1 d-block" }
const _hoisted_22 = { class: "list-unstyled mb-0" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 1,
  class: "py-3"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "px-2 font-weight-bold mb-1 d-block" }, "Tiendas destacadas", -1))
const _hoisted_26 = { class: "list-unstyled mb-0" }
const _hoisted_27 = { class: "d-block pr-2 pl-3 pointer py-1" }
const _hoisted_28 = {
  key: 0,
  class: "col col-1 border-right px-0 subSubCategory d-none"
}
const _hoisted_29 = { class: "py-3" }
const _hoisted_30 = { class: "px-2 font-weight-semibold mb-1 d-block" }
const _hoisted_31 = { class: "list-unstyled mb-0" }
const _hoisted_32 = ["onMouseenter"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "col flex-column p-0" }
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 0,
  class: "row no-gutters"
}
const _hoisted_37 = {
  key: 1,
  class: "c-loader-categories"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-loader-categories__icon" })
], -1))
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_ctx.showPanel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.categories.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _hoisted_9,
                          _createElementVNode("ul", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCategoryProduct(), (category, key) => {
                              return (_openBlock(), _createElementBlock("li", { key: key }, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["d-flex align-items-start pr-2 pl-3 py-1 pointer font-weight-bold", category === _ctx.currentCategory ? 'bg-primary text-white' : '']),
                                  onClick: ($event: any) => (_ctx.goTo(category.slug)),
                                  onMouseenter: ($event: any) => (_ctx.hoverCategory(category))
                                }, _toDisplayString(category.name), 43, _hoisted_11),
                                (category.depth === 2)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.categories, (subCategory, key) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                          key: key,
                                          onMouseenter: ($event: any) => (_ctx.hoverCategory(subCategory))
                                        }, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["d-flex align-items-start pr-2 pl-4 py-1 pointer font-weight-semibold", subCategory === _ctx.currentCategory ? 'bg-primary text-white' : '']),
                                            onClick: ($event: any) => (_ctx.goTo(subCategory.slug))
                                          }, _toDisplayString(subCategory.name), 11, _hoisted_14)
                                        ], 40, _hoisted_13))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _hoisted_15,
                          _createElementVNode("ul", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCategoryService(), (category, key) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: key,
                                onMouseenter: ($event: any) => (_ctx.hoverCategory(category)),
                                class: _normalizeClass(category === _ctx.currentCategory ? 'bg-primary text-white' : '')
                              }, [
                                _createElementVNode("span", {
                                  class: "d-flex align-items-start pr-2 pl-3 py-1 pointer font-weight-bold",
                                  onClick: ($event: any) => (_ctx.goTo(category.slug))
                                }, _toDisplayString(category.name), 9, _hoisted_18)
                              ], 42, _hoisted_17))
                            }), 128))
                          ])
                        ])
                      ]),
                      (_ctx.currentCategory)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (_ctx.currentCategory.categories.length > 0 && _ctx.currentCategory.depth < 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.currentCategory.name), 1),
                                  _createElementVNode("ul", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subCategories, (subCategory, key) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: key,
                                        class: _normalizeClass([_ctx.currentSubCategory === subCategory ? 'bg-primary text-white' : '', "hover-subcategory"])
                                      }, [
                                        _createElementVNode("span", {
                                          class: "d-flex align-items-start pr-2 pl-3 py-1 pointer font-weight-semibold",
                                          onClick: ($event: any) => (_ctx.goTo(subCategory.slug))
                                        }, _toDisplayString(subCategory.name), 9, _hoisted_23)
                                      ], 2))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.currentCategory && _ctx.currentCategory.commerces.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _hoisted_25,
                                  _createElementVNode("ul", _hoisted_26, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentCategory.commerces, (commerce, key) => {
                                      return (_openBlock(), _createElementBlock("li", { key: key }, [
                                        _createElementVNode("span", _hoisted_27, _toDisplayString(commerce.name), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.currentSubCategory && _ctx.currentSubCategory.categories.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.currentSubCategory.name), 1),
                          _createElementVNode("ul", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSubCategory.categories, (subCategory, key) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: key,
                                onMouseenter: ($event: any) => (_ctx.hoverSubSubCategory(subCategory))
                              }, [
                                _createElementVNode("span", {
                                  class: "d-block px-2 py-1 pointer",
                                  onClick: ($event: any) => (_ctx.goTo(subCategory.slug))
                                }, _toDisplayString(subCategory.name), 9, _hoisted_33)
                              ], 40, _hoisted_32))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("img", {
                      class: "image-category w-100",
                      src: _ctx.banner,
                      alt: "",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.bannerClick && _ctx.bannerClick(...args)))
                    }, null, 8, _hoisted_35),
                    (_ctx.theCategory && _ctx.theCategory.products.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theCategory.products, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id,
                              class: "col-12 col-md-3"
                            }, [
                              _createVNode(_component_ProductCard, { product: item }, null, 8, ["product"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
          ])
        ])), [
          [_directive_click_outside, _ctx.toggleBackdrop]
        ])
      ]))
    : _createCommentVNode("", true)
}